import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import ThemeContext from "components/app/Context";
import AccessBanner from "components/common/AccessBanner/PlanDetailAccessBanner";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { getPlanDetailsRoute, isTemplatePlan } from "utils/StoreUtils";
import "./ScrollAwareHeader.scss";

interface Props {
  children?: any;
  elementId?: string;
  sx?: any;
}

const ScrollAwareHeader = (props: Props) => {
  const { children, elementId, sx } = props;
  const { pathname } = useLocation();
  const { isMobileScreen } = useContext(ThemeContext);

  const [show, setShow] = useState(false);

  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);

  const isBannerShow = pathname.includes(getPlanDetailsRoute());

  const onScroll = () => {
    const yPos = window.scrollY;
    const yPosition =
      elementId && !isNaN(Number(elementId))
        ? Number(elementId)
        : elementId
          ? document.getElementById(elementId)?.scrollHeight ?? 80
          : 80;

    if (yPos > yPosition) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <Slide direction="down" in={show}>
      <Stack
        component={Paper}
        elevation={3}
        spacing={2}
        className={isImpersonated ? "impersonate-scroll header-scroll" : "non-impersonate-scroll header-scroll"}
      >
        {isBannerShow && (
          <>
            {" "}
            {isCorp && !isImpersonated && !isTemplatePlan() && (
              <div style={{ marginBottom: "16px" }}>
                <AccessBanner />
              </div>
            )}
          </>
        )}
        <div
          style={
            sx
              ? sx
              : {
                display: "flex",
                flexDirection: isMobileScreen ? "column" : "row",
                alignItems: isMobileScreen ? "flex-start" : "center"
              }
          }
        >
          {children}
        </div>
      </Stack>
    </Slide>
  );
};

export default ScrollAwareHeader;
